import { lazy } from 'react';

export const TermsOfServicePageAsync = lazy(
    () => import('./TermsOfServicePage'),
);
